import { useEffect, useState } from "react";
import { useGetAssignmentsQuery } from "../../../../../features/Assignments/assignmentsApi";
import AssignmentModal from "./AssignmentModal";
import { useGetSignleAssignmentMarkQuery } from "../../../../../features/AssignmentMark/assignmentMarkApi";
import { useSelector } from "react-redux";
import { selectUser } from "../../../../../features/Auth/selectAuth";
import { Link } from "react-router-dom";
import { useGetSingleQuizMarkQuery } from "../../../../../features/QuizMark/quizMarkApi";
import routes from "../../../../../config/routeConfig";

export default function VideoDetails({ video }) {
  const loggedInUser = useSelector(selectUser);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [skipGetSingleAssignMark, setSkipGetSingleAssignMark] = useState(true);

  const { title, description, id } = video || {};
  const { data: assingments } = useGetAssignmentsQuery();
  // check if video has assignment
  const videoAssignment = assingments?.find(
    (assignment) => assignment.video_id === id
  );

  // check if student has submitted assignment
  const { data: studentAssignment, refetch } = useGetSignleAssignmentMarkQuery(
    {
      student_id: loggedInUser?.student_id,
      assignment_id: videoAssignment?.id,
    },
    {
      skip: skipGetSingleAssignMark,
    }
  );
  // check if student has submitted quiz
  const { data: videoQuizMark } = useGetSingleQuizMarkQuery({
    student_id: loggedInUser?.student_id,
    video_id: id,
  });

  useEffect(() => {
    if (videoAssignment) {
      setSkipGetSingleAssignMark(false);
    }
  }, [skipGetSingleAssignMark, videoAssignment]);

  return (
    <div>
      <h1 className="text-lg font-semibold tracking-tight text-slate-100">
        {title}
      </h1>
      <h2 className=" pb-4 text-sm leading-[1.7142857] text-slate-400">
        Uploaded on 23 February 2020
      </h2>
      <div className="flex gap-4">
        {videoAssignment &&
          (studentAssignment?.length ? (
            <button className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary">
              আপনি এসাইনমেন্ট জমা দিয়েছেন
            </button>
          ) : (
            <button
              className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary"
              onClick={() => setIsModalOpen(true)}
            >
              এসাইনমেন্ট
            </button>
          ))}

        {!videoQuizMark?.length ? (
          <Link
            to={routes.student.quiz(id)}
            className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary"
          >
            কুইজে অংশগ্রহণ করুন
          </Link>
        ) : (
          <button className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary">
            কুইজ জমা দিয়েছেন
          </button>
        )}
      </div>
      <p className="mt-4 text-sm text-slate-400 leading-6">{description}</p>

      {isModalOpen && (
        <AssignmentModal
          loggedInUser={loggedInUser}
          assignment={videoAssignment}
          setIsModalOpen={setIsModalOpen}
          refetchStudentAssignment={refetch}
        />
      )}
    </div>
  );
}
